module.exports = __webpack_public_path__ + "static/media/14.37d41863.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/galeria/14.jpeg
// module id = 162
// module chunks = 0